import request from '@/utils/request';
const baseURL = '/upgrade/';

//取得軟體狀態
export function checkStatus() {
  return request({
    timeout: 30000,
    loading: false,
    method: 'get',
    url: `${baseURL}checkStatus`,
  });
}
//下載
export function download() {
  return request({
    method: 'get',
    url: `${baseURL}download`,
  });
}
//更新
export function upgrade() {
  return request({
    loading: false,
    method: 'get',
    url: `${baseURL}upgrade`,
  });
}
